import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementOrganizationFarmsAction} from '../action';

function* execute({payload}: GetManagementOrganizationFarmsAction): SagaIterator {
    const response = yield* call(Api.findAllByOrganizationIdForPrincipal, payload);

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOrganizationFarms(response.data));
    } else {
        yield putAll(showBeError(response, t('userDetail')('farmOptionsLoading')));
    }
}
/** Runs the admin saga that loads farm options for organization management. */
export function* getManagementOrganizationFarmsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_ORGANIZATION_FARMS', execute);
}
